import { render, staticRenderFns } from "./All_RequestPasswordReset.vue?vue&type=template&id=5a1e2c70&scoped=true&"
import script from "./All_RequestPasswordReset.vue?vue&type=script&lang=js&"
export * from "./All_RequestPasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./All_RequestPasswordReset.vue?vue&type=style&index=0&id=5a1e2c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e2c70",
  null
  
)

export default component.exports